import React, { useState, useEffect } from "react";
import NavigationMenu from "../Navigation/NavigationMenu";
import axios from "axios";

import {
  ChakraProvider,
  InputGroup,
  Input,
  InputRightElement,
  IconButton,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  FormControl,
  FormLabel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
} from "@chakra-ui/react";

import {
  SearchIcon,
  ViewIcon,
  EditIcon,
  DeleteIcon,
  AddIcon,
} from "@chakra-ui/icons";
import { useLocation } from "react-router-dom";

import "./AddHRPolicy.css";

const API_BASE_URL = `${process.env.REACT_APP_BACKEND_API || `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}`}`;

const AddHRPolicy = () => {
  const location = useLocation();

  const [name, setName] = useState("");
  const [doc, setDoc] = useState([""]);
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [policiesName, setPoliciesName] = useState([]);
  const initialDept = location.state?.hrpolicysearch;

  const fetchPolicies = async () => {
    try {
      if (
        initialDept !== null &&
        initialDept !== undefined &&
        initialDept !== "" &&
        initialDept !== " "
      ) {
        const response = await axios.get(
          `${API_BASE_URL}/HumanResource/hrpolicysearchfromdashboard/${initialDept}/`
        );
        setPolicies(response.data);
        console.log("Polices: ", response.data["name"]);
        const policyNames = policies.map((policy) => policy.name);
        setPoliciesName(policyNames);
        console.log("Initial HR Policy: ", initialDept);
        setLoading(false);
      } else {
        const response = await axios.get(
          `${API_BASE_URL}/HRPolicy/`
        );
        setPolicies(response.data);
        console.log("Polices: ", response.data["name"]);
        const policyNames = policies.map((policy) => policy.name);
        setPoliciesName(policyNames);
        console.log("Initial HR Policy: ", initialDept);
        setLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch policies", error);
      setLoading(false);
    }
  };
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedHRPolicy, setSelectedHRPolicy] = useState(null);
  // Create a new policy
  const createPolicy = async () => {
    const formData = new FormData();
    formData.append("name", name); // Ensure this is not an empty string
    if (doc) {
      formData.append("doc", doc);
    } else {
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}/HRPolicy/AddHRPolicy/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Policy Created:", response.data);
      setName("");
      setDoc(null);
      fetchPolicies(); // Refresh the list
    } catch (error) {
      console.error("Failed to create policy", error);
    }
  };

  // Update an existing policy
  const updatePolicy = async (id, policyData) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/HRPolicy/UpdateHRPolicy/${id}/`,
        policyData
      );
      console.log("Policy Updated:", response.data);
      fetchPolicies(); // Refresh the list
    } catch (error) {
      console.error("Failed to update policy", error);
    }
  };

  // Delete a policy
  const deletePolicy = async (id) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/HRPolicy/DeleteHRPolicy/${id}/`
      );
      console.log("Policy Deleted:", response.data);
      fetchPolicies(); // Refresh the list
    } catch (error) {
      console.error("Failed to delete policy", error);
    }
  };

  // Use Effect to load data on component mount
  useEffect(() => {
    fetchPolicies();
  }, []);

  const {
    isOpen: isOpenAddHRPolicy,
    onOpen: onOpenAddHRPolicy,
    onClose: onCloseAddHRPolicy,
  } = useDisclosure();
  const [policiesAddHRPolicy, setPoliciesAddHRPolicy] = useState([]);
  const [currentPolicyAddHRPolicy, setCurrentPolicyAddHRPolicy] = useState({
    name: "",
    file: null,
  });
  const [editingIndexAddHRPolicy, setEditingIndexAddHRPolicy] = useState(-1); // -1 when not editing

  const handleFileChangeAddHRPolicy = (e) => {
    setCurrentPolicyAddHRPolicy((prev) => ({
      ...prev,
      file: e.target.files[0],
    }));
  };

  const savePolicyAddHRPolicy = () => {
    const newPolicy = {
      ...currentPolicyAddHRPolicy,
      id:
        editingIndexAddHRPolicy === -1
          ? policiesAddHRPolicy.length + 1
          : policiesAddHRPolicy[editingIndexAddHRPolicy].id,
      createDate:
        editingIndexAddHRPolicy === -1
          ? new Date()
          : policiesAddHRPolicy[editingIndexAddHRPolicy].createDate,
    };

    let updatedPoliciesAddHRPolicy = [...policiesAddHRPolicy];
    if (editingIndexAddHRPolicy === -1) {
      updatedPoliciesAddHRPolicy.push(newPolicy);
    } else {
      updatedPoliciesAddHRPolicy[editingIndexAddHRPolicy] = newPolicy;
    }

    setPoliciesAddHRPolicy(updatedPoliciesAddHRPolicy);
    resetFormAddHRPolicy();
  };

  const resetFormAddHRPolicy = () => {
    setCurrentPolicyAddHRPolicy({ name: "", file: null });
    setEditingIndexAddHRPolicy(-1);
    onCloseAddHRPolicy();
  };

  const handleEditAddHRPolicy = (index) => {
    console.log("Selected index:", index);
    console.log("Policies at the time of edit:", policies);

    if (index >= 0 && index < policies.length) {
      const policy = policies[index];
      setName(policy.name); // Set name in state
      setDoc(policy.doc); // Set document in state, assuming `policy.doc` holds the document info
      setEditingIndexAddHRPolicy(index);
      onOpenAddHRPolicy();
    } else {
      console.error("Invalid index or empty policies array");
    }
    // setEditingIndexAddHRPolicy(index);
    // onOpenAddHRPolicy();
  };

  const handleEdit = (HRPolicy) => {
    setSelectedHRPolicy(HRPolicy);
    setIsEditModalOpen(true);
  };

  const handleDeleteAddHRPolicy = (index) => {
    setPoliciesAddHRPolicy(policiesAddHRPolicy.filter((_, i) => i !== index));
  };

  const handleCloseEditModal = () => {
    setSelectedHRPolicy(null);
    setIsEditModalOpen(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "No date provided"; // Fallback text or logic
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const handleSaveEdit = async () => {
    const formData = new FormData();
    formData.append("name", selectedHRPolicy.name); // Assuming 'name' is the state for the policy name
    if (selectedHRPolicy.doc) {
      formData.append("doc", selectedHRPolicy.doc); // Assuming 'doc' is the state containing the file
    }

    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}/HRPolicy/UpdateHRPolicy/${selectedHRPolicy.id}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setIsEditModalOpen(false);

      fetchPolicies();
    } catch (error) {
      console.error("Error updating HRPolicy:", error);
    }
  };

  //  Search

  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}/HRPolicy/SearchHRPolicy/?q=${inputValue}/`
      );
      setPolicies(response.data);
    } catch (error) {
      console.error("Failed to search policies", error);
    }
  };

  const [userStatus, setUserStatus] = useState(false);
  const [isSuperuser, setIsSuperUser] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API || `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}`}/HumanResource/user-status/`);
        if (response.status === 200) {
          console.log("Response: ", response.data)
          setUserStatus(response.data);
          setIsSuperUser(response.data.is_superuser);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  return (
    <>
      <NavigationMenu />
      <ChakraProvider>
        <div className="addHrPolicyWrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="addHrPolicyHeading">
                  <h1>HR Policy & Manuals</h1>
                  <p>
                    Guidelines for <span> Employee Management </span>and
                    Workplace Conduct
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-md-4 col-lg-4">
                <InputGroup className="hrPolicySearchInput">
                  <Input
                    placeholder="Search HR Policy"
                    onChange={handleInputChange}
                  />
                  <InputRightElement>
                    <IconButton
                      aria-label="Search database"
                      icon={<SearchIcon />}
                      onClick={handleSearch}
                      size="sm"
                    />
                  </InputRightElement>
                </InputGroup>
              </div>

              <div className="col-12 col-md-4 col-lg-4">
                <Button colorScheme="blue" onClick={handleSearch}>
                  Search
                </Button>
              </div>

              <div className="col-12 col-md-4 col-lg-4">
                <Button
                  leftIcon={<AddIcon />}
                  colorScheme="blue"
                  onClick={() => {
                    createPolicy();
                    onOpenAddHRPolicy();
                  }}
                >
                  Add Policy
                </Button>

                <Modal
                  isOpen={isOpenAddHRPolicy}
                  onClose={resetFormAddHRPolicy}
                >
                  <ModalOverlay />
                  <ModalContent>
                    <ModalHeader>
                      {editingIndexAddHRPolicy === -1
                        ? "Add a New Policy"
                        : "Edit Policy"}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                      <FormControl>
                        <FormLabel>Policy Name</FormLabel>
                        <Input
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        <FormLabel mt={4}>Attach Document</FormLabel>
                        <Input
                          type="file"
                          onChange={(e) => setDoc(e.target.files[0])}
                        />
                      </FormControl>
                    </ModalBody>

                    <ModalFooter>
                      <Button
                        colorScheme="blue"
                        mr={3}
                        onClick={async () => {
                          await createPolicy();
                          resetFormAddHRPolicy();
                        }}
                      >
                        Save
                      </Button>
                    </ModalFooter>
                  </ModalContent>
                </Modal>
              </div>
            </div>

            <Modal isOpen={isEditModalOpen} onClose={handleCloseEditModal}>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Edit HRPolicy</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <FormControl>
                    <FormLabel>HRPolicy Name</FormLabel>
                    <Input
                      type="text"
                      value={selectedHRPolicy ? selectedHRPolicy.name : ""}
                      onChange={(e) =>
                        setSelectedHRPolicy({
                          ...selectedHRPolicy,
                          name: e.target.value,
                        })
                      }
                    />
                    <label htmlFor="">Change File</label>
                    <Input
                      type="file"
                      // value={selectedHRPolicy ? selectedHRPolicy.doc : ""}
                      onChange={(e) =>
                        setSelectedHRPolicy({
                          ...selectedHRPolicy,
                          doc: e.target.files[0],
                        })
                      }
                    />
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <Button colorScheme="blue" onClick={handleSaveEdit}>
                    Save
                  </Button>{" "}
                  <Button onClick={handleCloseEditModal}>Cancel</Button>
                </ModalFooter>
              </ModalContent>
            </Modal>

            <div className="addHRPolicyViewWrapper">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-12">
                  <Box overflowX={"auto"}>
                    <Table
                      variant="simple"
                      mt={4}
                      className="hrPolicyTableFormat"
                    >
                      <Thead>
                        <Tr>
                          <Th width={"10%"}>Sr No.</Th>
                          <Th width={"25%"}>Policy Name</Th>
                          <Th width={"20%"}>Created Date</Th>
                          <Th width={"20%"}>Renew Date</Th>
                          <Th width={"5%"}>Document</Th>
                          {isSuperuser && (
                            <Th width={"20%"}>Actions</Th>
                          )}
                        </Tr>
                      </Thead>
                      <Tbody>
                        {policies.map((policy, index) => (
                          <Tr key={index}>
                            <Td>{index + 1}</Td>
                            <Td>{policy.name}</Td>
                            <Td>{formatDate(policy.created_date)}</Td>
                            <Td>
                              {formatDate(policy.renew_date)}
                            </Td>
                            <Td>
                              <IconButton
                                icon={<ViewIcon />}
                                aria-label="View Document"
                                onClick={() =>
                                  window.open(
                                    `${process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in'}${policy.doc}/`,
                                    "_blank"
                                  )
                                }
                              />
                            </Td>
                            {isSuperuser && (
                              <>
                                <Td>
                                  <IconButton
                                    icon={<EditIcon />}
                                    aria-label="Edit"
                                    mx={2}
                                    onClick={() => handleEdit(policy)} // This should prepare the form
                                  />
                                  <IconButton
                                    icon={<DeleteIcon />}
                                    aria-label="Delete"
                                    onClick={() => deletePolicy(policy.id)}
                                  />
                                </Td>
                              </>
                            )}
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ChakraProvider>
    </>
  );
};

export default AddHRPolicy;
